(() => {
const template = document.getElementById('terjung-search-default-template');
const setupCategoryStripBackground = () => {
const header = document.getElementById('site-header');
const links = header?.querySelector('.header-links');
if (!header || !links || links.dataset.terjungCategoryStripReady === 'true') return;
links.dataset.terjungCategoryStripReady = 'true';
let strip = header.querySelector('.terjung-category-strip-bg');
if (!strip) {
strip = document.createElement('div');
strip.className = 'terjung-category-strip-bg';
strip.setAttribute('aria-hidden', 'true');
header.prepend(strip);
}
header.classList.add('has-terjung-category-strip-bg');
let ticking = false;
const sync = () => {
ticking = false;
const headerRect = header.getBoundingClientRect();
const linksRect = links.getBoundingClientRect();
header.style.setProperty('--terjung-category-strip-top', linksRect.top - headerRect.top + 'px');
header.style.setProperty('--terjung-category-strip-height', linksRect.height + 'px');
};
const requestSync = () => {
if (ticking) return;
ticking = true;
window.requestAnimationFrame(sync);
};
sync();
window.addEventListener('resize', requestSync);
window.addEventListener('orientationchange', requestSync);
};
const setupStickyHeaderTop = () => {
const header = document.getElementById('site-header');
const top = header?.querySelector('.header__top');
if (!header || !top || top.dataset.terjungStickyTopReady === 'true') return;
top.dataset.terjungStickyTopReady = 'true';
let spacer = header.querySelector('.terjung-header-top-spacer');
if (!spacer) {
spacer = document.createElement('div');
spacer.className = 'terjung-header-top-spacer';
spacer.setAttribute('aria-hidden', 'true');
top.after(spacer);
}
let ticking = false;
let threshold = null;
const recalculateThreshold = () => {
const wasStuck = document.body.classList.contains('terjung-header-top-stuck');
if (wasStuck) document.body.classList.remove('terjung-header-top-stuck');
threshold = top.getBoundingClientRect().top + window.scrollY;
if (wasStuck) document.body.classList.add('terjung-header-top-stuck');
};
const sync = () => {
ticking = false;
if (threshold === null) recalculateThreshold();
const height = top.offsetHeight || 0;
header.style.setProperty('--terjung-sticky-header-height', height + 'px');
spacer.style.height = height + 'px';
document.body.classList.toggle('terjung-header-top-stuck', window.scrollY > threshold);
};
const requestSync = () => {
if (ticking) return;
ticking = true;
window.requestAnimationFrame(sync);
};
sync();
window.addEventListener('scroll', requestSync, { passive: true });
window.addEventListener('resize', () => {
threshold = null;
requestSync();
});
window.addEventListener('orientationchange', () => {
threshold = null;
requestSync();
});
};
const openSearch = (input) => {
const form = input?.closest('search-form');
if (!form || !input) return;
if (!form.querySelector('.terjung-search-drawer-close')) {
const close = document.createElement('button');
close.type = 'button';
close.className = 'terjung-search-drawer-close';
close.setAttribute('data-terjung-search-close', '');
close.setAttribute('aria-label', 'Suche schließen');
close.textContent = '×';
form.appendChild(close);
}
form.classList.add('is-terjung-search-open');
if (!input.dataset.terjungOriginalPlaceholder) {
input.dataset.terjungOriginalPlaceholder = input.getAttribute('placeholder') || '';
}
input.setAttribute('placeholder', 'Gib etwas ein...');
};
const renderDefault = (input) => {
const form = input.closest('search-form');
const results = form?.querySelector('[data-js-search-results]');
const overlay = document.getElementById(input.dataset.jsFocusOverlay);
openSearch(input);
if (!template || !results || !overlay || input.value.trim()) return;
results.innerHTML = template.innerHTML;
overlay.classList.add('active');
};
const closeSearch = (root = document) => {
root.querySelectorAll('.search-results-overlay.active').forEach((overlay) => overlay.classList.remove('active'));
root.querySelectorAll('search-form [data-js-search-results]').forEach((results) => { results.innerHTML = ''; });
root.querySelectorAll('search-form.is-terjung-search-open').forEach((form) => {
const input = form.querySelector('[data-js-search-input]');
if (input?.dataset.terjungOriginalPlaceholder !== undefined) {
input.setAttribute('placeholder', input.dataset.terjungOriginalPlaceholder);
}
form.classList.remove('is-terjung-search-open');
});
};
document.addEventListener('focusin', (event) => {
if (event.target.matches('search-form [data-js-search-input]')) {
openSearch(event.target);
window.setTimeout(() => renderDefault(event.target), 80);
}
});
document.addEventListener('click', (event) => {
const searchHandle = event.target.closest('#site-header .site-search-handle');
if (searchHandle && !event.target.closest('[data-terjung-search-close]')) {
const input = searchHandle.querySelector('[data-js-search-input]');
if (input) {
openSearch(input);
input.focus({ preventScroll: true });
window.setTimeout(() => renderDefault(input), 40);
}
}
const copyButton = event.target.closest('[data-terjung-copy-code]');
if (copyButton) {
event.preventDefault();
const code = copyButton.getAttribute('data-terjung-copy-code') || copyButton.textContent.trim();
const feedback = copyButton.closest('.terjung-header-system, #site-menu-sidebar')?.querySelector('[data-terjung-copy-feedback]');
const markCopied = () => {
copyButton.classList.add('is-copied');
if (feedback) {
feedback.textContent = 'Kopiert';
feedback.classList.add('is-visible');
}
window.setTimeout(() => {
copyButton.classList.remove('is-copied');
if (feedback) {
feedback.classList.remove('is-visible');
feedback.textContent = '';
}
}, 1800);
};
if (navigator.clipboard?.writeText) {
navigator.clipboard.writeText(code).then(markCopied).catch(markCopied);
} else {
const textarea = document.createElement('textarea');
textarea.value = code;
textarea.setAttribute('readonly', '');
textarea.style.position = 'fixed';
textarea.style.opacity = '0';
document.body.appendChild(textarea);
textarea.select();
try { document.execCommand('copy'); } catch (error) {}
textarea.remove();
markCopied();
}
}
if (event.target.closest('[data-terjung-search-close]')) {
closeSearch();
}
if (event.target.matches('.search-results-overlay')) {
closeSearch();
}
});
document.addEventListener('input', (event) => {
if (event.target.matches('search-form [data-js-search-input]')) {
openSearch(event.target);
if (!event.target.value.trim()) {
renderDefault(event.target);
}
}
});
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => {
setupCategoryStripBackground();
setupStickyHeaderTop();
}, { once: true });
} else {
setupCategoryStripBackground();
setupStickyHeaderTop();
}
window.addEventListener('load', () => {
setupCategoryStripBackground();
setupStickyHeaderTop();
}, { once: true });
})();
